import moment from "moment";
import { CALL_API } from "../../middlewares/api";

export const DCA_INFO_FETCH_REQUEST = "DCA_INFO_FETCH_REQUEST";
export const DCA_INFO_FETCH_SUCCESS = "DCA_INFO_FETCH_SUCCESS";
export const DCA_INFO_FETCH_ERROR = "DCA_INFO_FETCH_ERROR";

export function fetch_dca_info(ssn) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/find-debt-collection-loan?ssn=" + ssn,
      authenticatedRequest: true,
      types: [
        DCA_INFO_FETCH_REQUEST,
        DCA_INFO_FETCH_SUCCESS,
        DCA_INFO_FETCH_ERROR,
      ],
    },
  };
}

export const DCA_PAYMENT_REGISTER_REQUEST = "DCA_PAYMENT_REGISTER_REQUEST";
export const DCA_PAYMENT_REGISTER_SUCCESS = "DCA_PAYMENT_REGISTER_SUCCESS";
export const DCA_PAYMENT_REGISTER_ERROR = "DCA_PAYMENT_REGISTER_ERROR";

export function register_debt_collection_payment(
  amount,
  paymentNumber,
  originatorCreditId,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/register-debt-collection-payment",
      method: "POST",
      data: {
        Amount: amount,
        PaymentNumber: paymentNumber,
        OriginatorCreditId: originatorCreditId,
      },
      authenticatedRequest: true,
      types: [
        DCA_PAYMENT_REGISTER_REQUEST,
        DCA_PAYMENT_REGISTER_SUCCESS,
        DCA_PAYMENT_REGISTER_ERROR,
      ],
    },
  };
}

export const DCA_CREDIT_LOSS_REGISTER_REQUEST =
  "DCA_CREDIT_LOSS_REGISTER_REQUEST";
export const DCA_CREDIT_LOSS_REGISTER_SUCCESS =
  "DCA_CREDIT_LOSS_REGISTER_SUCCESS";
export const DCA_CREDIT_LOSS_REGISTER_ERROR = "DCA_CREDIT_LOSS_REGISTER_ERROR";

export function register_debt_collection_credit_loss(originatorCreditId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/register-debt-collection-credit-loss",
      method: "POST",
      data: { OriginatorCreditId: originatorCreditId },
      authenticatedRequest: true,
      types: [
        DCA_CREDIT_LOSS_REGISTER_REQUEST,
        DCA_CREDIT_LOSS_REGISTER_SUCCESS,
        DCA_CREDIT_LOSS_REGISTER_ERROR,
      ],
    },
  };
}

export const SOLD_LOANS_FETCH_REQUEST = "SOLD_LOANS_FETCH_REQUEST";
export const SOLD_LOANS_FETCH_SUCCESS = "SOLD_LOANS_FETCH_SUCCESS";
export const SOLD_LOANS_FETCH_ERROR = "SOLD_LOANS_FETCH_ERROR";

export function get_sold_candidates_loans() {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/debt-agency/loans-by-da-stage?DaStage=OfferedForSale",
      authenticatedRequest: true,
      types: [
        SOLD_LOANS_FETCH_REQUEST,
        SOLD_LOANS_FETCH_SUCCESS,
        SOLD_LOANS_FETCH_ERROR,
      ],
    },
  };
}

export const SELL_LOAN_REQUEST = "SELL_LOAN_REQUEST";
export const SELL_LOAN_SUCCESS = "SELL_LOAN_SUCCESS";
export const SELL_LOAN_ERROR = "SELL_LOAN_ERROR";

export function sell_loan(
  creditId,
  creditSoldDate,
  soldAmount,
  paymentId,
  OCR,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/sale",
      authenticatedRequest: true,
      method: "POST",
      data: {
        LoanId: creditId,
        Amount: soldAmount,
        BankReceiveDate: creditSoldDate,
        PaymentId: paymentId,
      },
      additionalData: { OCR },
      types: [SELL_LOAN_REQUEST, SELL_LOAN_SUCCESS, SELL_LOAN_ERROR],
    },
  };
}

function createPaymentId(loanTosell) {
  return (
    loanTosell.OCR +
    moment(loanTosell.bankReceiveDate).format("-YYYY-MM-DD-") +
    "ax"
  );
}

export function sell_loans_bulk(data) {
  if (data.length > 0) {
    let loanTosell = data[0];
    return {
      [CALL_API]: {
        endpoint: "/api/admin/debt-agency/sale",
        authenticatedRequest: true,
        method: "POST",
        data: {
          LoanId: loanTosell.loanId,
          BankReceiveDate: moment(loanTosell.bankReceiveDate).format(
            "YYYY-MM-DD",
          ),
          Amount: loanTosell.SoldAmount,
          PaymentId: createPaymentId(loanTosell),
        },
        additionalData: { OCR: loanTosell.OCR },
        types: [
          SELL_LOAN_REQUEST,
          { method: sell_loan_from_bulk_success.bind(this, data) },
          { method: sell_loan_from_bulk_error.bind(this, data) },
        ],
      },
    };
  } else return { type: "NO_MORE_LOANS_TO_SELL" };
}

function sell_loan_from_bulk_success(data, response) {
  return (dispatch) => {
    dispatch({
      type: SELL_LOAN_SUCCESS,
      dataSent: {
        LoanId: data[0].creditId,
        BankReceiveDate: data[0].creditSoldDate,
        Amount: data[0].soldAmount,
        PaymentId: data[0].paymentId,
      },
      response,
    });

    let modifiedData = data.slice(1);

    setTimeout(() => {
      dispatch(sell_loans_bulk(modifiedData));
    }, 1000);
  };
}

function sell_loan_from_bulk_error(data, error) {
  return (dispatch) => {
    dispatch({
      type: SELL_LOAN_ERROR,
      dataSent: {
        LoanId: data[0].creditId,
        BankReceiveDate: data[0].creditSoldDate,
        Amount: data[0].soldAmount,
        PaymentId: data[0].paymentId,
      },
      error,
    });

    let modifiedData = data.slice(1);

    setTimeout(() => {
      dispatch(sell_loans_bulk(modifiedData));
    }, 1000);
  };
}

export const CLEAR_PAYMENT_SENT_DATA = "CLEAR_PAYMENT_SENT_DATA";

export function clear_dialog_data() {
  return {
    type: CLEAR_PAYMENT_SENT_DATA,
  };
}
